import SimpleHeader from '../simpleHeader';
import Container from '../Container';
import useWindowWidth from '@/hooks/useWindowWidth';
import ResponsiveComponent from '../common/ResponsiveComponent';
import { ProcessLayoutProps } from '@/types/other';

const ProcessLayout = ({
  children,
  windowWidthSv = null,
}: ProcessLayoutProps) => {
  const windowWidth = useWindowWidth(windowWidthSv);
  return (
    <div>
      <ResponsiveComponent
        windowWidth={windowWidth}
        DesktopComponent={
          <>
            <SimpleHeader />
            <Container>{children}</Container>
          </>
        }
        MobileComponent={children}
      />
    </div>
  );
};

export default ProcessLayout;
